export default [
  {
    type: 'branchs_without_multselect',
    name: 'idBranch',
    label: 'field.store',
    help_text: 'kardex.select.choseStore',
    error_text: 'field_must_be_filled',
    required: true,
  },
  {
    type: 'input',
    name: 'cdLm',
    label: 'lm_label',
    help_text: 'mobile.hint.lm',
    error_text: 'field_must_be_filled',
    required: true,
    attrs: {
      minLength: 8,
      maxLength: 8,
      mask: '99999999',
    },
  },
  {
    type: 'date_month_year',
    name: 'dtRef',
    label: 'kardex.dtRef',
    help_text: 'kardex.field.dtRef.placeholder',
    error_text: 'field_must_be_filled',
    required: true,
  },
]
